import { Injectable, Renderer2, Inject, RendererFactory2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SharedSignalsService } from './shared-signals.service';
import { AuthService } from './auth.service';
import { EnvService } from 'src/app/env.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageService } from './local-storage.service';
import { SessionVariable } from '../enum/session-variable';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ExternalScriptsService {

  private renderer: Renderer2;
  orderDetails:any;

  transferSignal = inject(SharedSignalsService);

  constructor(@Inject(DOCUMENT) private document: Document, private rendererFactory: RendererFactory2,
  private storageService: LocalStorageService, private activatedRoute: ActivatedRoute, 
  private router: Router, 
  private authService : AuthService, public envService : EnvService, private ngxService: NgxUiLoaderService) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  loadScript(scriptUrl: string, callback: () => void): void {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptUrl;
    script.onload = callback;

    this.renderer.appendChild(this.document.body, script);
  }

  initTapSDKs(user:any): void {

    this.orderDetails = user;

    if(!user){
      return;
    }

    const { renderApplePayButton, ButtonStyle, Scope, SupportedNetworks, Locale, ButtonType, Environment, ThemeMode, Edges } = window['TapSDKs'];

    renderApplePayButton(
       {
          publicKey: "pk_live_4h2AcjLUvsR5yBxbo6frGXe1",
          environment: Environment.Development,
          scope: Scope.TapToken,
          merchant: {
              domain: 'www.dev-taly.io',
              id: 'merchant_fOhl5224538qed69EZ1e846'
          },
          
          interface: {
            locale: Locale.EN,
            theme: ThemeMode.DARK,
            type: ButtonType.PAY,
            edges: Edges.CURVED
          },
          transaction: {
            currency: 'KWD',
            amount: user?.amount
          },
           acceptance: {
              supportedBrands: [SupportedNetworks.Visa, SupportedNetworks.MasterCard],
               supportedCards: 'ALL',
               supportedCardsWithAuthentications: ['3DS']
           },
          customer: {
              id: null,
              name: [
                  {
                      locale: 'en',
                      first: user?.firstName,
                      last: user?.lastName
                  }
              ],
              contact: {
                  email: user?.emailAddress,
                  phone: {
                      number: user?.mobileNumber,
                      countryCode: user?.countryCode
                  }
              }
          },
          onCancel: async (error) => {
          //  debugger;
            console.group("onCancel")
            console.log('Payment cancelled');
            console.log(error)
            console.groupEnd()
           // this.ngxService.stop();

           // this.transferSignal.showMessage('Payment cancelled : > ', error);
          },
          onError: async (error) => {
        //    debugger;
            console.group("onError")
            console.log('Payment error');
            console.log(error)
            console.groupEnd()
            //this.transferSignal.showMessage('Payment error > ', error);
            //this.ngxService.stop();
          },
          onSuccess: async (data) => {
           // debugger;
            console.group("onSuccess")
            console.log('Payment successful');
            console.log(data)
            console.groupEnd()
            this.applePay(data?.id)
          },
          onReady: async (data) => {
            // debugger;
            console.log('Apple Pay button is ready');
            console.group("onReady")
            console.log('onReady');
            console.log(data)
            console.groupEnd()
          },
          onClick : async (data) => {
         //   debugger;
            console.log('Apple Pay button Click');
            console.group("onClick")
            console.log('onClick');
            console.log(data)
            console.groupEnd()
            //this.ngxService.start();
          }
       },
       'apple-pay-button'
    );
 }

 applePay(tokenId:any){
 // debugger;

  let payload = {
    "orderToken": this.orderDetails?.orderToken,
    "paymentPlanId": this.orderDetails?.paymentPlanId,
    "paymentMethod": "APPLEPAY",
    "paymentType" : "DOWNPAYMENT",
    "tokenId" : tokenId
  }

  this.authService.payByApplePay(payload).subscribe(res => {
    this.storageService.setItem(SessionVariable.PAID_BY_APPLE, true);
    this.storageService.setItem(SessionVariable.REDIRECTION_URL, res?.redirectUrl);
    this.storageService.setItem(SessionVariable.PAYMENT_REFERENCE, res?.paymentReference);
    this.ngxService.stopLoader('master');
    if (res.orderStatus == 'CONFIRMED' && res.paymentStatus == 'CAPTURED') {
      this.router.navigate(['/secure-checkout/', payload.orderToken, 'payment', 'success']);
    }
    else {
      this.storageService.setItem(SessionVariable.FAIL_ERROR_MSG, `Payment Reference ${res?.paymentReference} is ${res?.paymentStatus}`)
      this.router.navigate(['/secure-checkout/', payload.orderToken, 'payment', 'reject']);
    }
    //this.storageService.removeItem(SessionVariable.AUTO_PAY);
  }, err => {
    console.log(err);
    this.router.navigate(['../payment/reject'],{ relativeTo: this.activatedRoute });
    this.transferSignal.showMessage('Payment cancelled : > ', err?.message || err);
  })
 }

}
